import Loader from 'components/Layout/Loader';
import { cloneDeep, omit } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { useDispatch } from 'react-redux';
import { fetchAuthorEmailReciever } from 'store/slices';
import { icons, limit } from 'utils/constants';
import Label from '../Label';
import './AuthorEmailDropdown.scss';


const AuthorEmailDropdown = ({
    id,
    value,
    placeholder,
    error,
    onChange,
    existingList,
    handelInvite,
    label,
    isRequired,
    labelClass,
    filterID,
    showOnSearch,
    IsIcon,
    disabled,
}) => {
    const dispatch = useDispatch();
    const myRef = useRef();
    const listRef = useRef();
    const [isMenu, setIsMenu] = useState(false);
    const [memberLoading, setMemberLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [timer, setTimer] = useState('');
    const [userDetails, setUserDetails] = useState({
        userList: [],
        offset: 0,
        limit: limit,
        global_filter: '',
        total: 0,
    });
    const handelSearch = (e) => {
        e.preventDefault();
        const val = e.target.value;
        setSearchText(val);
        let time = timer;
        clearTimeout(time);
        time = setTimeout(() => {
            let oldData = cloneDeep({
                ...userDetails,
                offset: 0,
                global_filter: val.toLowerCase(),
            });
            listRef?.current?.scrollTo(0, 0);
            setUserDetails(oldData);
            getProfiles(oldData, true);
        }, 800);
        setTimer(time);
    };
    const handelScroll = (e) => {
        const bottom =
            e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            let oldData = cloneDeep({
                ...userDetails,
                offset: userDetails.offset + limit,
            });
            setUserDetails(oldData);
            getProfiles(oldData);
        }
    };
    const getProfiles = async (obj, isReset) => {
        let params = new URLSearchParams(omit(obj, ['userList', 'total']));
        let queryParams = params.toString();
        const response = await dispatch(fetchAuthorEmailReciever(queryParams));
        if (response?.status === 200) {
            setUserDetails((prev) => {
                const apiData = response?.data?.abstracts || [];

                let newData = isReset ? apiData : [...prev.userList, ...apiData];

                let filterArray = newData?.filter((o) => o?.id !== +value);

                if (filterID && filterID?.length > 0) {
                    filterArray = newData?.filter((o) => !filterID.includes(o?.id));
                }


                return {
                    ...prev,
                    total: response?.data?.count,
                    userList: filterArray,
                };
            });
        }
        setMemberLoading(false);
        return Promise.resolve();
    };
    const handleClickOutside = (e) => {
        if (myRef && myRef?.current && !myRef.current.contains(e.target)) {
            setIsMenu(false);
        }
    };
    useEffect(() => {
        if (!showOnSearch) {
            getProfiles(userDetails, true);
        } else {
            setMemberLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });

    const { userList, total } = userDetails;

    const findVal = [...userList, ...existingList]?.find(
        (o) => `${o.user_id}` === `${value}`
    );

    const showSugetion = showOnSearch ? (searchText ? true : false) : isMenu;

    const handleRemove = () => {
        onChange({
            target: {
                id: id,
                value: '',
                data: null,
            },
        });
        setSearchText('');
        setUserDetails((prev) => ({ ...prev, userList: [...prev.userList, ...existingList] }));
    };


    return (
        <div id="author-dropdown-container" ref={myRef}>
            {label && (
                <Label label={label} required={isRequired} className={labelClass} />
            )}
            <div
                className="search-input-block pointer"
                onClick={() => {
                    if (!memberLoading) {
                        setIsMenu(true);
                    }
                }}
            >
                {IsIcon && (
                    <div className="icon-wrapper" style={{ width: '24px' }}>
                        <img src={icons?.userOutline} alt="user" />
                    </div>
                )}

                <div className={findVal?.id ? 'active-text' : 'placeholder-color'}>
                    <input
                        type="text"
                        placeholder={
                            findVal?.id
                                ? `To : ${findVal?.authorName} | ${findVal?.paperId} | ${findVal?.paperTitle}`
                                : placeholder
                        }

                        onChange={handelSearch}
                        value={searchText}
                        className={handelInvite ? "elipsis-input" : ""}
                        style={{ paddingLeft: (IsIcon) ? "35px" : "14px" }}
                        disabled={disabled}
                    />
                </div>




                {/* <div
                    className="icon-block"
                    onClick={() => {
                        if (!memberLoading) {
                            setIsMenu(!isMenu);
                        }
                    }}
                >
                    {memberLoading ? (
                        <Loader size="sm" />
                    ) : (
                        <i className="bi bi-chevron-down pointer" />
                    )}
                </div> */}

                <div className="icon-block d-flex align-items-center">
                    {findVal?.id && (
                        <div
                            className="remove-icon me-2"
                            onClick={(e) => {
                                e.stopPropagation(); 
                                handleRemove();
                            }}
                            style={{ color: 'red', cursor: 'pointer' }}
                        >
                            <i className="bi bi-x-lg"></i>
                        </div>
                    )}

                    <div
                        onClick={() => {
                            if (!memberLoading) setIsMenu(!isMenu);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {memberLoading ? <Loader size="sm" /> : <i className="bi bi-chevron-down pointer"></i>}
                    </div>
                </div>


                {error && (
                    <span className="text-13-400 pt-1">
                        <span style={{ color: 'red' }}>{error}</span>
                    </span>
                )}
                {showSugetion && (
                    <div className="search-list-block shadow rounded">
                        <div
                            className="max-300 overflow-auto iferp-scroll"
                            ref={listRef}
                            onScroll={(e) => {
                                if (userList.length < total) {
                                    handelScroll(e);
                                }
                            }}
                        >
                            <ListGroup>
                                {userList?.map((elem, index) => {
                                    return (
                                        <ListGroup.Item
                                            key={index}
                                            action
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onChange({
                                                    target: {
                                                        id: id,
                                                        value: elem.user_id,
                                                        data: elem,
                                                    },
                                                });
                                                setIsMenu(false);
                                                setSearchText('');
                                            }}
                                        >
                                            {elem?.authorName} | {elem?.paperId} | {elem?.paperTitle}
                                        </ListGroup.Item>
                                    );
                                })}
                                {searchText && userList.length === 0 && (
                                    <ListGroup.Item className="text-center text-14-500">
                                        User not found
                                    </ListGroup.Item>
                                )}
                            </ListGroup>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default AuthorEmailDropdown;

